import { apiGetNews, apiGetMostPopularNews, apiGetFilteredNews, apiGetNewsArticle, apiGetMore } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import ARTICLE from '@/store/models/article';
import PAGINATION from '@/store/models/pagination';

// Services
import { mapEnabledToSlug } from '@/store/services/mapEnabledToSlug';

// initial state
const state = {
  single: {
    article: {
      story: ARTICLE
    },

    related: {}
  },

  popular: [],

  all: {
    data: [],
    meta: PAGINATION
  }
};

// mutations
const mutations = {
  [types.RECEIVED_NEWS] (state, articles) {
    state.all.data = articles.data;
    state.all.meta = articles.meta;
  },

  [types.RECEIVED_MOST_POPULAR_NEWS] (state, articles) {
    state.popular = articles;
  },

  [types.APPEND_NEWS] (state, articles) {
    state.all.data = state.all.data.concat(articles.data);
    state.all.meta = articles.meta;
  },

  [types.RECEIVED_NEWS_ARTICLE] (state, article) {
    state.single.article = article;
  },

  [types.RECEIVED_RELATED_NEWS] (state, articles) {
    state.single.related = articles;
  }
};

const actions = {
  getAllNews: ({ commit }, args = {}) => {
    return apiGetNews(args)
      .then(({ data }) => {
        commit(types.RECEIVED_NEWS, data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getMoreNews: ({ commit }, url) => {
    return apiGetMore(url)
      .then(({ data }) => {
        commit(types.APPEND_NEWS, data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getMostPopularNews: ({ commit }, args = {}) => {
    return apiGetMostPopularNews(args)
      .then(({ data }) => {
        commit(types.RECEIVED_MOST_POPULAR_NEWS, data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getNewsArticle: ({ commit }, slug) => {
    return apiGetNewsArticle(slug)
      .then(({ data }) => {
        commit(types.RECEIVED_NEWS_ARTICLE, data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getRelatedNews: ({ commit }, args = {}) => {
    return apiGetNews(args)
      .then(({ data }) => {
        commit(types.RECEIVED_RELATED_NEWS, data.data);
      })
      .catch((error) => {
        console.log(error);
    })
  }
};

const getters = {
  news (state) {
    return state;
  },

  newsArticle (state) {
    return state.single;
  },

  newsPopular (state) {
    return state.popular;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/news.js